import React from 'react';
import { Button } from './ui/Button';
import { Check, ShieldCheck } from 'lucide-react';
export function Hero() {
  const scrollToCompra = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative bg-gradient-to-b from-teal-50 to-white pt-6 pb-10 sm:pt-16 sm:pb-20 lg:pt-24 lg:pb-28 overflow-hidden min-h-screen flex items-center" data-id="element-21">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-22">
        <div className="max-w-5xl mx-auto text-center" data-id="element-23">
          {/* Badge */}
          <div className="inline-flex items-center gap-1.5 px-3 py-1 sm:px-4 sm:py-2 rounded-full bg-teal-100 text-teal-800 text-xs sm:text-sm font-semibold mb-3 sm:mb-6" data-id="element-24">
            <ShieldCheck className="w-3 h-3 sm:w-4 sm:h-4" data-id="element-25" />
            <span data-id="element-26">PARA PSICOPEDAGOGAS PROFESIONALES</span>
          </div>

          {/* Main Headline */}
          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-slate-900 tracking-tight mb-3 sm:mb-4 leading-tight px-2 sm:px-4" data-id="element-27">
            MEGA PACK{' '}
            <span className="text-teal-600 block mt-1 sm:mt-2" data-id="element-28">
              INTERVENCIÓN EN DISLEXIA
            </span>
          </h1>

          {/* Subtitle */}
          <p className="text-sm sm:text-lg md:text-xl text-slate-600 mb-2 sm:mb-3 max-w-3xl mx-auto px-4" data-id="element-29">
            Un sistema completo de 24 sesiones ya planificadas para intervenir
            dislexia con seguridad.
          </p>

          {/* Disclaimer */}
          <p className="text-xs sm:text-sm text-slate-500 italic mb-4 sm:mb-8 max-w-2xl mx-auto px-4" data-id="element-30">
            Este material es para psicopedagogas que trabajan en sesión real y
            necesitan estructura, no ideas sueltas.
          </p>

          {/* Product Image */}
          <div className="mb-3 sm:mb-8 flex justify-center" data-id="element-31">
            <a href="https://checkout.ebookditales.com/cart/42846653874239:1" className="group relative cursor-pointer transform transition-transform duration-300 hover:scale-105 focus:outline-none focus:ring-4 focus:ring-teal-500/50 rounded-lg" aria-label="Ver detalles del producto" data-id="element-32">
              <img src="https://cdn.magicpatterns.com/uploads/6sPbDk6xjDwVS5DA7a4jtn/WhatsApp_Image_2026-01-19_at_5.01.40_PM-removebg-preview.png" alt="Mega Pack de Intervención en Dislexia - Material imprimible con ejercicios de apoyo para dislexia 2026" className="w-full max-w-[240px] sm:max-w-lg lg:max-w-xl drop-shadow-2xl mx-auto" data-id="element-33" />
            </a>
          </div>

          {/* Subheading */}
          <h2 className="text-sm sm:text-xl md:text-2xl lg:text-3xl text-slate-700 font-bold mb-3 sm:mb-5 uppercase tracking-wide px-4" data-id="element-34">
            24 sesiones listas. Sin improvisar. Sin buscar material. Sin dudar
            en sesión.
          </h2>

          {/* CTA Button */}
          <div className="mb-4 sm:mb-8" data-id="element-35">
            <Button href="https://checkout.ebookditales.com/cart/42846653874239:1" variant="primary" withIcon className="text-xs sm:text-lg md:text-xl px-5 py-2.5 sm:px-10 sm:py-6 shadow-xl shadow-teal-200/50 w-full sm:w-auto" data-id="element-36">
              Quiero las 24 sesiones de dislexia listas para usar
            </Button>
          </div>

          {/* Features - Single Line */}
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs sm:text-sm font-medium text-slate-600 max-w-4xl mx-auto px-2" data-id="element-37">
            <div className="flex items-center gap-1.5" data-id="element-38">
              <Check className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-teal-500 flex-shrink-0" data-id="element-39" />
              <span data-id="element-40">24 sesiones estructuradas</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-41">
              <Check className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-teal-500 flex-shrink-0" data-id="element-42" />
              <span data-id="element-43">Fichas de trabajo listas para imprimir</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-44">
              <Check className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-teal-500 flex-shrink-0" data-id="element-45" />
              <span data-id="element-46">Registros clínicos profesionales</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-47">
              <Check className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-teal-500 flex-shrink-0" data-id="element-48" />
              <span data-id="element-49">Sistema progresivo de intervención en dislexia</span>
            </div>
          </div>
        </div>
      </div>

      {/* Abstract Background Decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-50">
        <div className="absolute -top-[10%] -left-[10%] w-[40%] h-[40%] rounded-full bg-teal-100/50 blur-3xl" data-id="element-51"></div>
        <div className="absolute top-[20%] -right-[10%] w-[30%] h-[30%] rounded-full bg-amber-100/50 blur-3xl" data-id="element-52"></div>
      </div>
    </section>;
}